export default __webpack_public_path__ + "static/media/LOGO CABANG DINAS-10.8279eea6.png";